module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing.f2923b1e1acad7bcb1278174c0ff80f8.png";